<template lang="pug">
  div.w-screen.grow.flex-col.flex.overflow-hidden
    //p.h-16.text-black {{previewing}} / {{editing}}
    undo-renderer(v-show='!previewing && editing',:editing='editing',
      ref='undoRenderer',
      :transforms-and-source='transformsAndSource',
      :template='hasTemplate ? gamedata.template : undefined'
      @play='previewing = true',
      @next='onNext'
      @animate='$emit("animate")'
      @placement='$emit("placement")'
      @add-undo='$emit("add-undo")',
      @force-autosave='$emit("save-activity")',
      @remove-draft='$emit("remove-draft")'
      @select='onSelect'
      @post='onPost'
      @first-load='$emit("first-load")'
      :background-color='backgroundColor')
    editor-player(v-if='previewing || !editing',
      :gamedata='gamedata',
      :transformsAndSource='transformsAndSource'
      :enable-toolbar='true'
      :title='title'
      class='overflow-hidden flex flex-col grow'
      @post='onPost'
      @edit='goBackFromPosting')

</template>
<script>
import { mapState } from 'vuex';
import UndoRenderer from './UndoRenderer.vue';
import EditorPlayer from '@edit/organisms/EditorPlayer.vue';

export default {
  props:{
    gamedata:{
      type:Object,
      required:true
    },
    transformsAndSource:{
      type:Object,
      required:true
    },
    backgroundColor:{
      type:String,
      default:'#000000'
    },
    enableUnloadWarning:{
      type:Boolean,
      default: true
    },
    editing:{
      type:Boolean,
      default:true
    },
    title:{
      type:String,
      default:''
    },
    editTemplate:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      num: 0,
      previewing: false
    }
  },
  mounted() {
    if (this.hasTemplate) {
      this.prepareTemplate();
    }
    this.$ana.track({
      eventCategory:'editor',
      eventAction:'startEditor'
    });
    window.addEventListener('beforeunload', this.onBeforeUnload);

    /*
    this.counter = 0;
    setInterval( () => {
      console.log('counter', this.counter);
      this.editing = !this.editing;
      this.counter++;
    }, 2200);
    */

  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.onBeforeUnload);
  },
  methods: {
    onSelect(data) {
      this.$emit('select', data);
    },
    goBackFromPosting() {
      this.previewing = false;
      if (!this.isAdvancedMode) {
        this.$emit("back");
      }
      //console.log('go back from posting!!!!');
      //this.previewing = false;
      //@edit='previewing = false; if (!isAdvancedMode) { $emit("back") }',)
    },
    onSelectTopMode(mode) {
      if (mode === 'post') {
      } else {
        this.$refs.undoRenderer.onSelectTopMode(mode);
      }
    },
    onPost() {
      this.$emit('post');
    },
    onNext() {
      this.$emit('next');
    },
    test() {
      this.num++;
    },
    _resized() {
      this.isWidescreen = this.$el.getBoundingClientRect().width > 800;
      this.editor.setIsSmallScreen(!this.isWidescreen);
    },
    onBeforeUnload(event) {
      if (!this.enableUnloadWarning) {
        return;
      }
      const message = "Data will be lost if you leave or refresh the page, are you sure?";
      if (typeof(event) !== 'undefined') {
        event.returnValue = message;
      }
      return message;
      
    },
    prepareTemplate() {
      if (!this.template.blockedSelections) {
        const blockedSelections = [];
        const transforms = this.transformsAndSource.gamedata.findAllTransforms();
        transforms.forEach( ({id}) => {
          if (!this.possibleTemplateSelections.includes(id)) {
            blockedSelections.push(id);
          }
        });
        this.$set(this.gamedata.template, 'blockedSelections', blockedSelections);
      }
    }
  },
  components:{
    UndoRenderer,
    EditorPlayer
  },
  computed:{
    hasTemplate() {
      return !this.editTemplate && !!this.gamedata.template;
    },
    template() {
      return this.gamedata.template;
    },
    possibleTemplateSelections() {
      return (this.template.components||[]).map( ({transform}) => {
        return transform;
      })
    },
    ...mapState(['isAdvancedMode'])
  },
  watch:{
    editing(nv) {
      if (nv) {
        this.$ana.track({
          eventCategory:'editor',
          eventAction:'showEditor'
        });
        this.$emit('save-activity');
        this.$emit('top-mode', {mode:this.$refs.undoRenderer.currentTopMode});
      } else {
        this.$ana.track({
          eventCategory: 'editor',
          eventAction:'showPreview'
        });
        this.$emit('save-activity');
      }
      this.$emit('editing', nv);
    },
    enableUnloadWarning(nv) {
      if (!nv) {
        window.removeEventListener('beforeunload', this.onBeforeUnload);
      } else {
        window.addEventListener('beforeunload', this.onBeforeUnload);
      }
    }
  }
}
</script>
